'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setLocale = setLocale;
exports.setMessages = setMessages;
exports.setLocaleAndMessages = setLocaleAndMessages;
var SET_LOCALE = exports.SET_LOCALE = 'SET_LOCALE';
var SET_MESSAGES = exports.SET_MESSAGES = 'SET_MESSAGES';
var SET_LOCALE_AND_MESSAGES = exports.SET_LOCALE_AND_MESSAGES = 'SET_LOCALE_AND_MESSAGES';

function setLocale(locale) {
  return {
    type: SET_LOCALE,
    payload: locale
  };
}

function setMessages(messages) {
  return {
    type: SET_MESSAGES,
    payload: messages
  };
}

function setLocaleAndMessages(locale, messages) {
  return {
    type: SET_LOCALE_AND_MESSAGES,
    payload: {
      locale: locale,
      messages: messages
    }
  };
}


/*****************
 ** WEBPACK FOOTER
 ** ./~/@its/components/lib/Container components/IntlProviderContainer/actions.js
 ** module id = 170
 ** module chunks = 0
 **/